import { useReducer } from 'react';
import { Details, File, FormMarkup } from '@components/basicComponents';
import { handleFormSubmit } from '@utils/forms';
import { getNetworkingArubaCentralFormData, NetworkingArubaCentralFormFields } from '.';
import type { FormExtendedEvent } from 'grommet/components/Form';
import type { FormProps, FormFieldsDetailsProps } from '@customTypes/types';
import type { SingleFormState } from '@customTypes/stateTypes';

const formTitle: string = 'HPE Networking Aruba Central';

export const NetworkingArubaCentralForm = (props: FormProps): JSX.Element => {
  const [state, updateState] = useReducer(
    (prev: SingleFormState, newState: Partial<SingleFormState>) => ({
      ...prev,
      ...newState,
    }),
    {
      showDetails: false,
      numFiles: 0,
    }
  );

  const onDetailsChange = (value: FormFieldsDetailsProps) => {
    updateState(value);
  };

  const onFileChange = (value: number): void => {
    updateState({ numFiles: value });
  };

  const onSubmit = ({ target, value }: FormExtendedEvent): void => {
    const data = getNetworkingArubaCentralFormData(target, value.helpWith);

    handleFormSubmit(data, props.onSuccess, props.onError, props.onLoading);
  };

  let clearFormFieldsState;

  const assignClearFormFieldsState = (formFieldsClearStateFunc: Function): void => {
    clearFormFieldsState = formFieldsClearStateFunc;
  };

  const onReset = (): void => {
    clearFormFieldsState && clearFormFieldsState();
    updateState({ numFiles: 0 });
  };

  return (
    <FormMarkup
      onSubmit={onSubmit}
      onReset={onReset}
      formTitle={formTitle}
      doubleFieldPhone
      formFields={
        <>
          <NetworkingArubaCentralFormFields onDetailsChange={onDetailsChange} onReset={assignClearFormFieldsState} />

          {state.showDetails &&
            <>
              <Details required={true} />

              <File numFiles={state.numFiles} onFileChange={onFileChange} />
            </>
          }
        </>
      }
    />
  );
};
